import React from "react";
import { useHistory } from "react-router-dom";

// Types
import { Language } from "../../types/Language.types";

// Utils
import { LOCAL_STORAGE_LANGUAGE_CODE } from "../../constants/LocalStorage";

const LanguageItem: React.FC<Language> = (props: Language) => {
  const history = useHistory();

  const clickHandler = () => {
    localStorage.setItem(LOCAL_STORAGE_LANGUAGE_CODE, props.countryCode);
    history.push(`/${props.countryCode}/login`);
  };

  return (
    <li onClick={clickHandler}>
      <p>{props.language}</p>
      <div className="flag-container">
        {props.flagIcons.map((flag, index) => (
          <img key={index} src={flag.sourceUrl} alt="" />
        ))}
      </div>
    </li>
  );
};

export default LanguageItem;
